import { http } from '../http'
import userGWFragments from '@shared/hooks/usegwFragments'

export const getOrdersStatusList = async (date: { startDate: string, endDate: string }): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/statuses',
      data: {
        ...userFragments,
        ...date
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.message)
  }

  return data.data.data
}
